module.exports = __webpack_public_path__ + "static/media/logo.74bb2765.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = ./src/assets/logo.svg
// module chunks = 0